// https://observablehq.com/@namitmohale/stacked-bar-chart@752
import define1 from "./a33468b95d0b15b0@699.js";

export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], function(md){return(
md`# Stacked Bar Chart

Population by age and state. Compare to [horizontal stacked bars](/@d3/stacked-horizontal-bar-chart), [normalized stacked bars](/@d3/stacked-normalized-horizontal-bar), [grouped bars](https://observablehq.com/@d3/grouped-bar-chart) and a [dot plot](/@d3/dot-plot). Data: [American Community Survey](/@mbostock/working-with-the-census-api)`
)});
  main.variable(observer("chart")).define("chart", ["d3","width","height","titleText","titleSize","xAxis","yAxis","series","color","x","y","formatValue","margin","dotRadius","labelSize"], function(d3,width,height,titleText,titleSize,xAxis,yAxis,series,color,x,y,formatValue,margin,dotRadius,labelSize)
{
  // const minX = x(series[0][0].data.name);
  // const maxX = x(series[0][series[0].length - 1].data.name);
  // const overwidth = maxX - minX + margin.left + margin.right;
  
  const svg = d3.create("svg")
      .attr("viewBox", [0, 0, width, height]);

  svg.append("g").append('text')
     .text(titleText)
     .attr('y', 5)
      .attr('x', width/2)
  .attr("text-anchor", "middle")
    .style("alignment-baseline", "hanging")
     .attr('font-weight', 'bold')
     .style('font-size', titleSize);
  
  
  svg.append("g")
      .attr("class", "x-axis")
      .call(xAxis);

  svg.append("g")
      .call(yAxis);
  
  // svg.append("g")
  //     .style("overflow-x", "scroll")
  //     .style("-webkit-overflow-scrolling", "touch");
  
  svg.append("g")
    .selectAll("g")
    .data(series)
    .join("g")
      .attr("fill", d => color(d.key))
    .selectAll("rect")
    .data(d => d)
    .join("rect")
      .attr("x", (d, i) => x(d.data.name) + 5)
      .attr("y", d => y(d[1]))
      .attr("height", d => y(d[0]) - y(d[1]))
      .attr("width", x.bandwidth()-10)
    .append("title")
      .text(d => `${d.data.name} \n${d.key}: ${formatValue(d.data[d.key])}`);

  
  svg.selectAll("mydots")
    .data(series.map(d => d.key))
    .enter()
    .append("circle")
    .attr("cx", width-margin.right+20)
    .attr("cy", function(d,i){ return 20 + i*25})
    .attr("r", dotRadius)
    .style("fill", function(d){ return color(d)})
            
  svg.selectAll("mylabels")
    .data(series.map(d => d.key))
    .enter()
    .append("text")
    .attr("x", width-margin.right+35)
    .attr("y", function(d,i){ return 20 + i*25})
    .style("fill", function(d){ return color(d)})
    .text(function(d){ return d.charAt(0).toUpperCase() + d.slice(1)})
    .attr("text-anchor", "left")
    .style("alignment-baseline", "middle")
    .style("font-size", labelSize)
  
  return svg.node();
}
);
  main.variable(observer("zoom")).define("zoom", ["margin","width","height","d3","x","xAxis"], function(margin,width,height,d3,x,xAxis){return(
function zoom(svg) {
  const extent = [[margin.left, margin.top], [width - margin.right, height - margin.top]];

  svg.call(d3.zoom()
      .scaleExtent([1, 8])
      .translateExtent(extent)
      .extent(extent)
      .on("zoom", zoomed));

  function zoomed(event) {
    x.range([margin.left, width - margin.right].map(d => event.transform.applyX(d)));
    svg.selectAll("rect").attr("x", d => x(d.data.name)).attr("width", x.bandwidth());
    svg.selectAll(".x-axis").call(xAxis);
  }
}
)});
  main.variable(observer("wrap")).define("wrap", ["d3"], function(d3){return(
(text) => {
        const width=50
        text.each(function() {
          var text = d3.select(this),
              words = text.text().split(/\s+/).reverse(),
              word,
              line = [],
              lineNumber = 0,
              lineHeight = 1.1, // ems
              y = text.attr("y"),
              dy = parseFloat(text.attr("dy")),
              tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
          while (words.length >0) {
              word=words.pop()
            line.push(word);
            tspan.text(line.join(" "));
            // if (tspan.node().getComputedTextLength() > width) {
              line.pop();
              tspan.text(line.join(" "));
              line = [word];
              tspan = text.append("tspan").attr("x", 0).attr("y", y-10).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
            // }
          }
        });
      }
)});
  main.variable(observer("text")).define("text", function(){return(
"name,Active,Inactive\rData,6,2\rMarketing,2,7\rDevelopment,10,0\rProduct Management,5,5\rHuman Resources,4,6\rPM,6,2\rSales,2,7\rC Levels,10,0\rTeam Leads,5,5\rMisc,4,6\r"
)});
  main.variable(observer()).define(["series"], function(series){return(
series[0][9].data.name
)});
  main.variable(observer("data")).define("data", ["d3","text"], function(d3,text){return(
d3.csvParse(text, (d, i, columns) => (d3.autoType(d), d.total = d3.sum(columns, c => d[c]), d)).sort((a, b) => b.total - a.total)
)});
  main.variable(observer("series")).define("series", ["d3","data"], function(d3,data){return(
d3.stack()
    .keys(data.columns.slice(1))
  (data)
    .map(d => (d.forEach(v => v.key = d.key), d))
)});
  main.variable(observer("x")).define("x", ["d3","data","margin","width"], function(d3,data,margin,width){return(
d3.scaleBand()
    .domain(data.map(d => d.name))
    .range([margin.left, width - margin.right])
    .padding(0.1)
)});
  main.variable(observer("y")).define("y", ["d3","series","height","margin"], function(d3,series,height,margin){return(
d3.scaleLinear()
    .domain([0, d3.max(series, d => d3.max(d, d => d[1]))])
    .rangeRound([height - margin.bottom, margin.top])
)});
  main.variable(observer("color")).define("color", ["d3","series","colorRange"], function(d3,series,colorRange){return(
d3.scaleOrdinal()
  .domain(series.map(d => d.key))
  .range(colorRange)
)});
  main.variable(observer("xAxis")).define("xAxis", ["height","margin","d3","x","xTextSize","wrap"], function(height,margin,d3,x,xTextSize,wrap){return(
g => g
    .attr("transform", `translate(0,${height - margin.bottom})`)
    .call(d3.axisBottom(x).tickSizeOuter(0))
    .attr('font-size', xTextSize)
    .selectAll("text").call(wrap, x.bandwidth())
    .call(g => g.selectAll(".domain").remove())
)});
  main.variable(observer("yAxis")).define("yAxis", ["margin","d3","y","yTextSize"], function(margin,d3,y,yTextSize){return(
g => g
    .attr("transform", `translate(${margin.left},0)`)
    .call(d3.axisLeft(y).ticks(null, "s"))
    .attr('font-size', yTextSize)
    .call(g => g.selectAll(".domain").remove())
)});
  main.variable(observer("xTextSize")).define("xTextSize", function(){return(
13
)});
  main.variable(observer("yTextSize")).define("yTextSize", function(){return(
15
)});
  main.variable(observer("colorRange")).define("colorRange", ["d3"], function(d3){return(
d3.schemePastel1
)});
  main.variable(observer("titleText")).define("titleText", function(){return(
"Active/Inactive Employees per Team"
)});
  main.variable(observer("titleSize")).define("titleSize", function(){return(
18
)});
  main.variable(observer("dotRadius")).define("dotRadius", function(){return(
8
)});
  main.variable(observer("labelSize")).define("labelSize", function(){return(
15
)});
  main.variable(observer("formatValue")).define("formatValue", function(){return(
x => isNaN(x) ? "N/A" : x.toLocaleString("en")
)});
  main.variable(observer("height")).define("height", function(){return(
450
)});
  main.variable(observer("margin")).define("margin", function(){return(
{top: 50, right: 90, bottom: 50, left: 30}
)});
  main.variable(observer("d3")).define("d3", ["require"], function(require){return(
require("d3@6")
)});
  const child1 = runtime.module(define1);
  main.import("legend", child1);
  return main;
}
